module.exports = __webpack_public_path__ + "img/fukushin.ad04768e.png";